import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Outline } from 'pdfjs-dist/types/src/display/editor/drawers/outline';

@Component({
  selector: 'app-building-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './building-modal.html',
  styleUrl: './building-modal.scss'
})
export class BuildingModal {
 @Input() showConstructionModal: boolean = false;
 @Input() description: string = 'Esta herramienta estará disponible próximamente.';
 @Input() descriptionSecondary: string = 'Vuelve pronto para probarla';
@Output() closeModal = new EventEmitter<void>();

  closeConstructionModal(): void {
    this.closeModal.emit();
  }
}
